import { FormlyFieldConfig } from '@ngx-formly/core';
import { Injectable, Injector } from '@angular/core';
import { Logger } from 'src/app/core/logger';
import { RenderService } from './render.service';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsSectionModel } from 'src/app/models/widgets/widgets-section.model';
import { CloneService } from 'src/app/services/clone/clone.service';
import { CommandInputService } from 'src/app/services/command/command-input.service';
import { AbstractRender } from 'src/app/abstract/render.abstract';
import { camelize } from '@angular-devkit/core/src/utils/strings';
import { Config } from 'src/app/config';

@Injectable({
  providedIn: 'root',
})
export class RenderSectionService extends AbstractRender {
  // For testing purposes
  // TODO: need to double check if making these fields public has done side effect...
  public lastSectionRendered;
  public field!: FormlyFieldConfig;
  public questionBlock;

  constructor(private injector: Injector, private logger: Logger) {
    super();
  }

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
  render(
    widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean
  ) {
    // let currentWidget;
    // let field: FormlyFieldConfig;

    try {
      if (widget.widgetType === WidgetsTypeEnum.SECTION) {
        this.lastSectionRendered = widget as WidgetsSectionModel;

        // Go up to custom model and overrides labels
        // TODO: Check if label overrides are needed for SECTIONS
        const labelOverrides: Map<string, string> = new Map<string, string>();
        CloneService.getLabelOverrides(
          widget,
          widgetRoot,
          labelOverrides
        );
        const overridedString = CloneService.overrideText(
          this.lastSectionRendered.label,
          labelOverrides
        );

        // TODO: Decide levels for Section label/title
        const sectionTitleHeaderLevel = 2;

        if (this.lastSectionRendered.hidden) {
          this.field = {
            // template: '<h'+sectionTitleHeaderLevel+'>'+currentWidget.seq + '. ' + overridedString+'</h'+sectionTitleHeaderLevel+'>',
            props: {
              // fxLayout: 'row nowrap',
              description: 'SECTION',
            },
            fieldGroup: []
          };
        } else {
          this.field = {
            // type: 'flex-layout',
            wrappers: ['section'],
            // fieldGroupClassName: 'display-flex',
            key: this.isFlatModelSubmitEnabled() ? undefined : 'section-' + this.lastSectionRendered.seq,
            props: {
              // fxLayout: 'row nowrap',
              description: 'SECTION',
              label: overridedString,
              sequence: this.lastSectionRendered.seq,
              seqHidden: this.lastSectionRendered.seqHidden,
              // TODO Only if initial question enabled
              initialQuestionLabel: this.lastSectionRendered.initialQuestionLabel,
              initialQuestionEnabled:
                this.lastSectionRendered.isInitialQuestionEnabled,
            },
            fieldGroup: [],
          };
          if (this.lastSectionRendered.isInitialQuestionEnabled === true) {
            // TODO: modify to looks like a normal yes/no question
            let sectionKey = camelize(this.lastSectionRendered.label);
            sectionKey = (this.lastSectionRendered.initialQuestionKey && this.lastSectionRendered.initialQuestionKey !== '') ? 
              this.lastSectionRendered.initialQuestionKey.replace(/[^a-zA-Z0-9 ]/g, "") : 
              sectionKey.replace(/[^a-zA-Z0-9 ]/g, "") + 'InitialQuestion';
            this.questionBlock =
            {
              fieldGroupClassName: "primitive-radio",
              fieldGroup: [
                {
                  template: "<div>" + this.lastSectionRendered.initialQuestionLabel + "</div>",
                  className: "prop-label"
                },
                {
                  key: sectionKey,
                  require: true,
                  type: 'uw-radio',
                  defaultValue: true,
                  props: {
                    options: [
                      { value: 'Yes', label: 'Yes', selected: true },
                      { value: 'No', label: 'No' }
                    ],
                    required: true,
                    isInitialSectionQuestion: true
                  },
                  className: "prop-radio"
                }
              ]
            };
            this.field.fieldGroup?.push(this.questionBlock);
          }
        }

        // Mix created input with widget template.
        // TODO: Check if this makes sense for sections
        if (this.lastSectionRendered.template) {
          const modelTemplate = JSON.parse(this.lastSectionRendered.template);
          this.field = Object.assign({}, this.field, modelTemplate);
        }
        config.push(this.field);

        // Now render children (questions)
        if (isRecursive) {
          const renderService = this.injector.get(RenderService);
          this.lastSectionRendered.children.forEach((childWidget) => {
            // eslint-disable-next-line
            renderService.render(childWidget, this.field.fieldGroup!, widgetRoot, formlyRoot, isInsideQuestion, isRecursive);
          });
        }
      }
    } catch (error) {
      this.logger.log(error);
    }
  }

  isFlatModelSubmitEnabled(): boolean {
    if (Config.FEATURES.get('isFlatModelSubmitEnabled')) {
      return Config.FEATURES.get('isFlatModelSubmitEnabled') as boolean;
    }
    return false;
  }
}
